import type { ReactiveController, ReactiveControllerHost } from 'lit';

/** Tracks a media query, re-rendering the host whenever it flips. */
export class MediaQueryController implements ReactiveController {
    matches: boolean;

    private _host: ReactiveControllerHost;
    private _mq: MediaQueryList;
    private _onChange?: (matches: boolean) => void;

    constructor(host: ReactiveControllerHost, query: string, onChange?: (matches: boolean) => void) {
        this._host = host;
        this._mq = window.matchMedia(query);
        this.matches = this._mq.matches;
        this._onChange = onChange;
        host.addController(this);
    }

    hostConnected(): void {
        this._mq.addEventListener('change', this._handleChange);
    }

    hostDisconnected(): void {
        this._mq.removeEventListener('change', this._handleChange);
    }

    private _handleChange = (e: MediaQueryListEvent): void => {
        this.matches = e.matches;
        this._host.requestUpdate();
        this._onChange?.(e.matches);
    };
}
